var _path, _path2, _path3, _path4, _path5, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNhnSolutionLine2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 129,
    viewBox: "0 0 129 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.2188 34.8506H88.1497C92.8005 34.8506 96.5708 38.6208 96.5708 43.2716V45.223H65.6246C63.0419 45.223 60.602 44.0378 59.0054 42.0078L58.7942 41.7392C57.9159 40.6224 56.7693 39.746 55.4612 39.1916L45.2188 34.8506Z",
    stroke: "white",
    strokeWidth: 1.68421
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.2687 34.8496C21.6179 34.8496 17.8477 38.6198 17.8477 43.2707V94.993C17.8477 99.6438 21.6179 103.414 26.2687 103.414H102.835C107.486 103.414 111.256 99.6438 111.256 94.993V53.643C111.256 48.9922 107.486 45.222 102.835 45.222H66.1408C63.6824 45.222 61.3468 44.1477 59.7469 42.2812L55.8979 37.7904C54.298 35.9239 51.9624 34.8496 49.504 34.8496H26.2687Z",
    fill: "#513DC3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7469 42.2812L60.3863 41.7331L60.3863 41.7331L59.7469 42.2812ZM18.6898 43.2707C18.6898 39.0849 22.083 35.6917 26.2687 35.6917V34.0075C21.1528 34.0075 17.0056 38.1548 17.0056 43.2707H18.6898ZM18.6898 94.993V43.2707H17.0056V94.993H18.6898ZM26.2687 102.572C22.083 102.572 18.6898 99.1787 18.6898 94.993H17.0056C17.0056 100.109 21.1528 104.256 26.2687 104.256V102.572ZM102.835 102.572H26.2687V104.256H102.835V102.572ZM110.414 94.993C110.414 99.1787 107.021 102.572 102.835 102.572V104.256C107.951 104.256 112.098 100.109 112.098 94.993H110.414ZM110.414 53.643V94.993H112.098V53.643H110.414ZM102.835 44.3799H66.1408V46.0641H102.835V44.3799ZM66.1408 44.3799C63.9282 44.3799 61.8262 43.413 60.3863 41.7331L59.1075 42.8292C60.8674 44.8824 63.4365 46.0641 66.1408 46.0641V44.3799ZM60.3863 41.7331L56.5373 37.2424L55.2585 38.3385L59.1075 42.8292L60.3863 41.7331ZM26.2687 35.6917H49.504V34.0075H26.2687V35.6917ZM56.5373 37.2424C54.7774 35.1892 52.2082 34.0075 49.504 34.0075V35.6917C51.7166 35.6917 53.8186 36.6586 55.2585 38.3385L56.5373 37.2424ZM112.098 53.643C112.098 48.5271 107.951 44.3799 102.835 44.3799V46.0641C107.021 46.0641 110.414 49.4573 110.414 53.643H112.098Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5292 57.9238C32.7747 55.3293 34.9533 53.3472 37.5594 53.3472H56.6908C59.2969 53.3472 61.4755 55.3293 61.721 57.9238L64.0279 82.3047C64.3085 85.27 61.9763 87.8333 58.9978 87.8333H35.2525C32.274 87.8333 29.9418 85.27 30.2223 82.3047L32.5292 57.9238Z",
    stroke: "white",
    strokeWidth: 1.68421
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9581 59.8491C53.9581 63.6259 50.8965 66.6876 47.1197 66.6876C43.3429 66.6876 40.2812 63.6259 40.2812 59.8491",
    stroke: "white",
    strokeWidth: 5.05263,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 101.09,
    cy: 53.3476,
    r: 2.36127,
    stroke: "white",
    strokeWidth: 1.68421
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.205,
    cy: 53.3476,
    r: 2.36127,
    stroke: "white",
    strokeWidth: 1.68421
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNhnSolutionLine2);
export default __webpack_public_path__ + "static/media/nhnSolutionLine2.8e37c9bef953bd5ae0a64d60d1ee3f43.svg";
export { ForwardRef as ReactComponent };